import { useMemo } from 'react';
import FallBack from '../FallBack';
import ErrorContent from '../ErrorContent';
import TemplatesCarousel from '../TemplatesCarousel';
import IContent from './types';

const Content = ({ isLoading, templates, isError, scrollCount }: IContent) => {
  const renderContent = useMemo(() => {
    if (isLoading) {
      return <FallBack />;
    }
    if (isError || templates.length < 1) {
      return <ErrorContent />;
    }
    return <TemplatesCarousel templates={templates} scrollCount={scrollCount} />;
  }, [isError, isLoading, templates]);

  return renderContent;
};

export default Content;
